import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import styles from "./Styles.module.scss";
import { Box } from "@mui/material";

const bannerThree = require("../../../../images/redShoesBanner.jpg");
const bannerFour = require("../../../../images/batBlueBanner.png");
const mobileSaudShakeel = require("../../../../images/shoesBannerMobile.jpg");
const mobileIftikhar = require("../../../../images/Bats-Banner.psd-2.jpg");
const solm = require("../../../../images/Purple-and-Blue-Modern-Choose-Your-Best-Partner-Banner-Landscape-(1).jpg");
const solmMoblie = require("../../../../images/mobile-size.jpg");
const HeaderBanner = () => {
  return (
    <Swiper
      navigation={true}
      modules={[Navigation, Autoplay]}
      className={`${styles.swiper} swiperC`}
      autoplay={{
        delay: 6000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }}
    >
      
      <SwiperSlide className={styles["swiper-slide"]} position="relative">
        <Box
          component="img"
          className={` ${styles.mobileImage}`}
          src={mobileSaudShakeel}
          loading="lazy"
        />
        <Box
          component="img"
          className={styles.photo2}
          src={bannerThree}
          loading="lazy"
        />
      </SwiperSlide>
      <SwiperSlide className={styles["swiper-slide"]} position="relative">
        <Box
          component="img"
          className={` ${styles.mobileImage}`}
          src={solmMoblie}
          loading="lazy"
        />
        <Box
          component="img"
          className={styles.photo2}
          src={solm}
          loading="lazy"
        />
      </SwiperSlide>
      <SwiperSlide className={styles["swiper-slide"]} position="relative">
        {/* <Box component="div" className={styles.headerSliderText}>        
        </Box> */}
        <Box
          component="img"
          className={` ${styles.mobileImage}`}
          src={mobileIftikhar}
          loading="lazy"
        />
        <Box
          component="img"
          className={styles.photo2}
          src={bannerFour}
          loading="lazy"
        />
      </SwiperSlide>
    </Swiper>
  );
};

export default HeaderBanner;
